module.exports = __webpack_public_path__ + "e-learning-app/static/img/3.9353d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = ZK0V
// module chunks = 1